import React, { useRef, useState, useEffect } from 'react';
import useInbox from '../../../api/panel/inbox';
import NotificationsList from './NotificationsList';
import DesktopNotificationToggle from './DesktopNotificationToggle';
import { FaBell } from 'react-icons/fa';

export default function NotificationBell() {
    const { inbox } = useInbox({ page: 1, limit: 10, unreadOnly: true, refetchMs: 30000 });
    const unreadCount = inbox.data?.unread || 0;

    const [open, setOpen] = useState(false);
    const wrapRef = useRef(null);

    // close on outside click
    useEffect(() => {
        const onDocClick = (e) => {
            if (!wrapRef.current) return;
            if (!wrapRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, []);

    return (
        <div ref={wrapRef} className="notification-area">
            <button
                type="button"
                className="btn notification-area"
                onClick={() => setOpen((o) => !o)}
                aria-label="Notifications"
            >
                <FaBell />
                {unreadCount > 0 && (
                    <span className="notification-alert-bubble position-absolute rounded-pill bg-danger">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
                )}
            </button>

            {open && (
                <div
                    className="card shadow-sm"
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: '110%',
                        width: 360,
                        maxHeight: 420,
                        overflow: 'auto',
                        zIndex: 1050,
                    }}
                >
                    <NotificationsList />
                    <DesktopNotificationToggle />
                    <div className="p-2 border-top text-center">
                        <a href="/admin/my-notifications" className="btn btn-sm btn-outline-secondary w-100">
                            View all notifications
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
}
